import { planTypes } from '@/mocks/solutionsData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function PlanShowcase() {
  return (
    <section className="relative bg-white py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <img
          src={readdy('plan-show-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">方案类型</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                选择合适的方案，开启健康蜕变之旅
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            {planTypes.map((plan, index) => (
              <ScrollReveal key={plan.name} variant="scale-up" delay={index * 120}>
                <div
                  className={`rounded-2xl overflow-hidden border border-brand-light/40 hover:border-brand-cream hover:shadow-lg transition-all duration-300 group ${
                    index === 1 ? 'lg:-mt-6 lg:mb-6 ring-2 ring-brand-deep/10' : ''
                  }`}
                >
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img
                      src={plan.image}
                      alt={plan.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4">
                      <span className={`text-xs font-medium px-3 py-1.5 rounded-full ${plan.tagColor}`}>
                        {plan.tag}
                      </span>
                    </div>
                    {index === 1 && (
                      <div className="absolute top-4 left-4 bg-brand-gold text-white text-xs font-medium px-3 py-1 rounded-full">
                        全程守护
                      </div>
                    )}
                  </div>

                  <div className="p-6 md:p-8">
                    <h3 className="text-lg font-semibold text-brand-deep mb-1">{plan.name}</h3>
                    <p className="text-xs text-brand-brown mb-4">建议服务周期：{plan.period}</p>
                    <p className="text-gray-400 text-xs leading-relaxed mb-5">{plan.desc}</p>
                    <ul className="space-y-2.5">
                      {plan.features.map((feature) => (
                        <li key={feature} className="flex items-start gap-2">
                          <i className="ri-check-line text-brand-green text-sm flex-shrink-0 mt-0.5" />
                          <span className="text-xs text-gray-500">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}